/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  getCompanySearch,
  requestEmployees,
} from "../../../apis/companies/companies";
import useForm from "../../../hooks/useForm";
import { get, isEmpty } from "lodash-es";
import Input from "../../../components/Input";
import Guide from "../../../components/Guide";
import IconButton from "../../../components/Button/IconButton";
import SearchIcon from "../../../assets/images/icon/search-icon-3.svg";
import { Link, useHistory } from "react-router-dom";
import { classnames } from "../../../utils/text";
import { transformComNum } from "../../../utils/validator/comNum";
import consultingPopup from "../../../utils/consulting";
import { getCompnayNum } from "../../../utils/storage";

const RequestJoinCompany = () => {
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({})
  const [isToggle, setIsToggle] = useState(false)
  const [isFirst, setIsFirst] = useState(true);
  const [searchText, setSearchText] = useState("")
  const history = useHistory();

  const submit = (data) => {
    setIsFirst(false)
    setSearchText(data.query)
    getCompanySearch(data)
      .then((res) => {
        setCompanyList(res.data.companies);
        setSelectedCompany(get(res, "data.companies[0]") || {});
        // reset();
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const { errors, values, handleOnChange, handleSubmit, setValidateFields } = useForm({
    query: "",
  },
    submit,
  );

  const goCreateCompnay = () => {
    history.push('/create-company')
  }
  const [comNum, setCompnayNum] = useState(null);
  useEffect(() => {
    if (getCompnayNum()) {
      setCompnayNum(getCompnayNum())
      submit({ query: getCompnayNum() })
    }
  }, [])

  useEffect(() => {
    setValidateFields([
      { label: '검색어', key: 'query', type: 'inpyut', min: 2, validators: ['required'] },
    ])
  }, [])

  const handleRequest = () => {
    if (isEmpty(selectedCompany)) return;

    requestEmployees(selectedCompany.idx)
      .then(() => { })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleOnClickCompany = (idx) => {
    setSelectedCompany(companyList[idx])
    setIsToggle(false)
  }

  return (
    <div className="Layout auth-wrap">
      <div className="JoinCompany">
        <h1>직원등록 요청</h1>
        {!comNum && <>
          <p className="sub-title">회사 찾기</p>
          <Guide
            textAlign="left"
            children={
              <div className="guide-text-wrap">
                <p>상호명, 대표명으로 검색시 두글자 이상</p>
                <p>사업자번호로 검색시 끝까지 입력해주세요</p>
              </div>
            }
          />
          <form onSubmit={handleSubmit}>
            <div className="request-container">
              <div className="reqeust-filter-wrap">
                <Input
                  name="query"
                  value={values.query}
                  placeholder="상호명, 대표명, 사업자번호 중에서 검색"
                  onChange={handleOnChange}
                />
                <IconButton
                  icon={SearchIcon}
                  onClick={handleSubmit}
                />
                {errors && <p className="error-message">{errors.query}</p>}
              </div>
              {/* <div className="request-btn-warp clear">
              <Button
                onClick={handleSubmit}
                className="mt-16 float-right"
              >
                검색
              </Button>
            </div> */}
            </div>
          </form>
          {!isFirst && isEmpty(companyList) &&
            <div className="company-list-container color-gray-5" style={{
              lineHeight: 1.5,
              fontSize: "12px"
            }}>
              "{searchText}"에 대한 검색 결과가 없습니다.<br />
              상호명, 대표명, 사업자번호는 정확하게 입력되어야합니다.<br />
              찾으시는 회사가 없는 경우 아래 "신규 기업 등록"을 통해 등록해 주세요.
            </div>
          }
        </>}

        {!isEmpty(companyList) && (
          <div className="company-list-container">
            {/* <div className="company-list-wrap">
              <select
                className="company-list"
                onChange={(e) => setSelectedCompanyIdx(e.target.value)}
              >
                {companyList.map((company, index) => (
                  <option
                    key={index}
                    value={company.idx}
                  >{`${company.name}/${company.comNum}/${company.ceoName}`}</option>
                ))}
              </select>
            </div> */}
            <div className="custom-select-container">
              <div className="custom-selected-view" onClick={() => {
                setIsToggle(!isToggle);
              }}>
                <p className="company-name">
                  {get(selectedCompany, 'type') === 2 && "[세무사] "}
                  {get(selectedCompany, 'type') === 3 && "[노무사] "}
                  {get(selectedCompany, 'type') === 9 && "[경리대행] "}
                  {get(selectedCompany, 'name')}
                </p>
                <div className="company-info-wrap">
                  <span className="company-num">{transformComNum(get(selectedCompany, 'comNum'))}</span>
                  <span className="ceo">대표</span><span className="company-ceo-name">{get(selectedCompany, 'ceoName')}</span>
                </div>
              </div>
              <ul className={classnames("custom-options-view", { open: isToggle })}>
                {companyList.map((company, idx) => (
                  <li key={idx} className="custom-options" onClick={() => handleOnClickCompany(idx)}>
                    <p className="company-name">
                      {company.name}
                    </p>
                    <div className="company-info-wrap">
                      <span className="company-num">{transformComNum(company.comNum)}</span>
                      <span className="ceo">대표</span><span className="company-ceo-name">{company.ceoName}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button className="company-select-btn" onClick={handleRequest}>
              직원 등록 요청하기
            </button>
          </div>
        )}
        <div className="horizontal-divider" />
        <div className="inquire-wrap float-left">
          <div className="inquire-button-wrap">
            <a
              className="cursor-pointer"
              onClick={() => {
                consultingPopup(true)
              }}
            >WeCake에 문의</a>
          </div>
        </div>
        <div className="inquire-wrap float-right">
          <div className="logout-button-wrap">
            <Link to="/logout">로그아웃</Link>
          </div>
        </div>
        <div className="clear">
          <button
            onClick={goCreateCompnay} 
            className="btn btn-secondary btn-lg w-full mt-24" >
            신규 기업 등록
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestJoinCompany;
